import React from 'react';
import { Box, Typography, FormControl, PropTypes } from '@material-ui/core';
import Select from 'react-select';
import { TranslatedTextV2 } from '../TranslatedText';

interface ISelectOption {
  label: string;
  id: string | number;
}

interface ISelectFieldProps {
  label?: {
    translationKey: string;
    defaultText: string;
  };
  placeholder?: {
    translationKey: string;
    defaultText: string;
  };
  field: string;
  value: Array<string | number> | string | number | null;
  options: Array<ISelectOption>;
  onValueChange: (
    value: Array<string | number> | string | number | null
  ) => void;
  isMulti?: boolean;
  containerStyle?: React.CSSProperties;
  fromControlProps?: {
    margin?: PropTypes.Margin;
  };
  closeMenuOnSelect?: boolean;
  menuPortalTarget?: HTMLElement | null | undefined;
}
export const UncontrolledSelectField = (props: ISelectFieldProps) => {
  return (
    <Box style={{ ...props.containerStyle }}>
      {props.label && (
        <Typography style={{ fontWeight: 500, fontSize: '14px' }}>
          <TranslatedTextV2
            translationKey={props.label.translationKey}
            defaultText={props.label.defaultText}
          />
        </Typography>
      )}
      <FormControl {...props.fromControlProps} fullWidth>
        <Select
          placeholder={
            props.placeholder ? (
              <TranslatedTextV2
                translationKey={props.placeholder.translationKey}
                defaultText={props.placeholder.defaultText}
              />
            ) : (
              'Select...'
            )
          }
          closeMenuOnSelect={
            typeof props.closeMenuOnSelect === 'boolean'
              ? props.closeMenuOnSelect
              : false
          }
          value={(props.options ?? []).filter(
            (value) =>
              (Array.isArray(props.value)
                ? props.value
                : [props.value]
              ).indexOf(value.id) >= 0
          )}
          onChange={(value) => {
            const getValue = (
              value: Array<ISelectOption> | ISelectOption | null | []
            ) => {
              if (props.isMulti) {
                if (Array.isArray(value)) return value.map((item) => item.id);
                else return [];
              } else {
                if (value) return (value as ISelectOption).id;
                else return null;
              }
            };
            props.onValueChange(getValue(value as any));
          }}
          isMulti={props.isMulti ?? false}
          name={props.field}
          options={props.options ?? []}
          className="basic-multi-select"
          classNamePrefix="select"
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => `${option.id}`}
          menuPortalTarget={
            props?.menuPortalTarget === null
              ? props?.menuPortalTarget
              : document.body
          }
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 99 }) }}
        />
      </FormControl>
    </Box>
  );
};

export default UncontrolledSelectField;
